import gql from 'graphql-tag';
import client from '../graphqlAPI';

const GET_LOYALTY_PRIZES = gql`
  query getLoyaltyPrizes {
    getLoyaltyPrizes {
      isAuth
      generatedAt
      items {
        slugName
        postName
        active
        hasPost
        won
        claimed
        conversion
        codesTotal
        codesUsed
        codesLeft
        firstUploadedAt
        lastUploadedAt
        firstClaimAt
        lastClaimAt
        status
        onDemand
      }
    }
  }
`;

const getLoyaltyPrizes = async (variables) => {
  try {
    const result = await client.query({
      query: GET_LOYALTY_PRIZES, variables, errorPolicy: 'all', fetchResults: true, fetchPolicy: 'no-cache',
    }).catch((queryError) => {
      console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ getLoyaltyPrizes Query Error: ${queryError}`);
      return null;
    });
    return result && result.data ? result.data.getLoyaltyPrizes : null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ getLoyaltyPrizes Error: ${error}`);
    return null;
  }
};

export default getLoyaltyPrizes;
